import React from "react";

import '../css/Footer.css';
import { getOSSImage } from "./Utils";

const wechatImage = getOSSImage('qiyeweixin.png');
const qrcode = getOSSImage('erweima.png');
const footerLogo = getOSSImage('logo_foot_with_name.png');
const mailIcon = getOSSImage('b_youxiang.png');
const locationIcon = getOSSImage('b_dizhi.png');

export default function Footer() {

    const openMail = () => {
        window.open("mailto:hello@animepop.net", "_blank");
    }

    const openICPSite = () => {
        window.open("https://beian.miit.gov.cn/", "_blank");
    }

    const openPrivacy = () => {
        window.open("https://www.animepop.net/privacy.html", "_blank");
    }

    return (
        <div id='footer' className="footer-container">
            <img className="wechat-image" alt="wechat" src={wechatImage} />
            <img className="qr-code" alt="qr-code" src={qrcode} />
            <img className="footer-logo" alt="footer-logo" src={footerLogo} />
            <div className="footer-line" />
            <img className="mail-icon" alt="icon" src={mailIcon} />
            <div className="mail-link"><span onClick={openMail}>hello@animepop.net</span></div>
            <img className="location-icon" alt="icon" src={locationIcon} />
            <div className="location-link"><span>北京市・大兴区黄村镇芦城工业区管委会院内 1 号</span></div>

            <div className="info-text copyright"><span>COPYRIGHT © ANIMEPOP.NET ALL RIGHTS RESERVED</span></div>
            <div className="info-text tip"><span>* APP画面仅为示例，图中内容或活动以APP内公示为准</span></div>

            <div className="info-line" />
            <div className="info-text beian" onClick={openICPSite}>
                <span>京ICP备2024042231号-3</span>
            </div>
            <div className="info-line1" />
            <div className="info-text privacy" onClick={openPrivacy}>
                <span>隐私声明</span>
            </div>
        </div>
    )
}